/**
 * EMPRICS Image Gallery
 * Handles slide navigation, thumbnail selection, lightbox zoom,
 * keyboard navigation, and touch swipe for product/project galleries.
 */
(function () {
  'use strict';

  class EmpicsGallery {
    constructor(el) {
      this.root = el;
      this.slides = Array.from(el.querySelectorAll('[data-slide-index]'));
      this.thumbs = Array.from(el.querySelectorAll('[data-thumb-index]'));
      this.current = 0;
      this.total = this.slides.length;

      if (this.total === 0) return;

      this.prevBtn = el.querySelector('[data-gallery-prev]');
      this.nextBtn = el.querySelector('[data-gallery-next]');
      this.zoomBtn = el.querySelector('[data-gallery-zoom]');

      const lbId = el.id + '-lightbox';
      this.lightbox = document.getElementById(lbId);
      this.lbImg = this.lightbox ? this.lightbox.querySelector('[data-lightbox-img]') : null;
      this.lbClose = this.lightbox ? this.lightbox.querySelector('[data-lightbox-close]') : null;

      this.touchStartX = 0;
      this.touchEndX = 0;

      this.bind();
    }

    bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = parseInt(thumb.getAttribute('data-thumb-index'), 10);
          this.goTo(idx);
        });
      });

      if (this.zoomBtn) {
        this.zoomBtn.addEventListener('click', () => this.openLightbox());
      }

      // Click main image to zoom
      this.slides.forEach((slide) => {
        const img = slide.querySelector('.emprics-gallery__image');
        if (img) {
          img.addEventListener('click', () => this.openLightbox());
        }
      });

      if (this.lbClose) {
        this.lbClose.addEventListener('click', () => this.closeLightbox());
      }
      if (this.lightbox) {
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox || e.target.classList.contains('emprics-gallery__lightbox-viewport')) {
            this.closeLightbox();
          }
        });
      }

      // Keyboard
      this.root.setAttribute('tabindex', '0');
      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
        if (e.key === 'Escape' && this.lightbox && !this.lightbox.hidden) {
          this.closeLightbox();
        }
      });

      // Touch swipe
      const viewport = this.root.querySelector('.emprics-gallery__viewport');
      if (viewport) {
        viewport.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        viewport.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        }, { passive: true });
      }
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      const threshold = 50;
      if (Math.abs(diff) < threshold) return;
      if (diff > 0) this.next();
      else this.prev();
    }

    goTo(index) {
      if (index < 0 || index >= this.total) return;
      this.slides[this.current].classList.remove('emprics-gallery__slide--active');
      this.slides[index].classList.add('emprics-gallery__slide--active');

      if (this.thumbs[this.current]) {
        this.thumbs[this.current].classList.remove('emprics-gallery__thumb--active');
      }
      if (this.thumbs[index]) {
        this.thumbs[index].classList.add('emprics-gallery__thumb--active');
        this.thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      this.current = index;
    }

    next() { this.goTo((this.current + 1) % this.total); }
    prev() { this.goTo((this.current - 1 + this.total) % this.total); }

    openLightbox() {
      if (!this.lightbox || !this.lbImg) return;
      const activeSlide = this.slides[this.current];
      const img = activeSlide.querySelector('.emprics-gallery__image');
      if (!img) return;

      const zoomSrc = img.getAttribute('data-zoom-src') || img.src;
      this.lbImg.src = zoomSrc;
      this.lbImg.alt = img.alt;
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';

      // Trap focus
      this.lbClose.focus();
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.hidden = true;
      document.body.style.overflow = '';
      this.zoomBtn ? this.zoomBtn.focus() : this.root.focus();
    }
  }

  function init() {
    document.querySelectorAll('[data-gallery]').forEach((el) => {
      new EmpicsGallery(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
